/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVmMongo } from '../models/custom-result-of-audit-vm-mongo';
import { CustomResultOfListOfOutboxMessageNumbersCountByDeliveryStatusDto } from '../models/custom-result-of-list-of-outbox-message-numbers-count-by-delivery-status-dto';
import { CustomResultOfOutboxMessageNumbersWithPaginationDto } from '../models/custom-result-of-outbox-message-numbers-with-pagination-dto';
import { outboxMessageNumbersApplyingToGetNewDeliveryStatusGet } from '../fn/outbox-message-numbers/outbox-message-numbers-applying-to-get-new-delivery-status-get';
import { OutboxMessageNumbersApplyingToGetNewDeliveryStatusGet$Params } from '../fn/outbox-message-numbers/outbox-message-numbers-applying-to-get-new-delivery-status-get';
import { outboxMessageNumbersApplyingToGetNewDeliveryStatusPost } from '../fn/outbox-message-numbers/outbox-message-numbers-applying-to-get-new-delivery-status-post';
import { OutboxMessageNumbersApplyingToGetNewDeliveryStatusPost$Params } from '../fn/outbox-message-numbers/outbox-message-numbers-applying-to-get-new-delivery-status-post';
import { outboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId } from '../fn/outbox-message-numbers/outbox-message-numbers-get-outbox-message-delivery-status-statistics-by-scheduled-message-id';
import { OutboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId$Params } from '../fn/outbox-message-numbers/outbox-message-numbers-get-outbox-message-delivery-status-statistics-by-scheduled-message-id';
import { outboxMessageNumbersGetOutboxMessageNumbersAudit } from '../fn/outbox-message-numbers/outbox-message-numbers-get-outbox-message-numbers-audit';
import { OutboxMessageNumbersGetOutboxMessageNumbersAudit$Params } from '../fn/outbox-message-numbers/outbox-message-numbers-get-outbox-message-numbers-audit';
import { outboxMessageNumbersGetScheduledMessageNumbersAndTextWithPagination } from '../fn/outbox-message-numbers/outbox-message-numbers-get-scheduled-message-numbers-and-text-with-pagination';
import { OutboxMessageNumbersGetScheduledMessageNumbersAndTextWithPagination$Params } from '../fn/outbox-message-numbers/outbox-message-numbers-get-scheduled-message-numbers-and-text-with-pagination';
import { outboxMessageNumbersGetScheduledMessageNumbersWithPagination } from '../fn/outbox-message-numbers/outbox-message-numbers-get-scheduled-message-numbers-with-pagination';
import { OutboxMessageNumbersGetScheduledMessageNumbersWithPagination$Params } from '../fn/outbox-message-numbers/outbox-message-numbers-get-scheduled-message-numbers-with-pagination';
import { outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdGet } from '../fn/outbox-message-numbers/outbox-message-numbers-update-delivery-status-by-delivery-status-and-scheduled-message-id-get';
import { OutboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdGet$Params } from '../fn/outbox-message-numbers/outbox-message-numbers-update-delivery-status-by-delivery-status-and-scheduled-message-id-get';
import { outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdPost } from '../fn/outbox-message-numbers/outbox-message-numbers-update-delivery-status-by-delivery-status-and-scheduled-message-id-post';
import { OutboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdPost$Params } from '../fn/outbox-message-numbers/outbox-message-numbers-update-delivery-status-by-delivery-status-and-scheduled-message-id-post';
import { outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusGet } from '../fn/outbox-message-numbers/outbox-message-numbers-update-out-box-message-numbers-delivery-status-get';
import { OutboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusGet$Params } from '../fn/outbox-message-numbers/outbox-message-numbers-update-out-box-message-numbers-delivery-status-get';
import { outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusPost } from '../fn/outbox-message-numbers/outbox-message-numbers-update-out-box-message-numbers-delivery-status-post';
import { OutboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusPost$Params } from '../fn/outbox-message-numbers/outbox-message-numbers-update-out-box-message-numbers-delivery-status-post';
import { outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusGet } from '../fn/outbox-message-numbers/outbox-message-numbers-update-selected-out-box-message-numbers-delivery-status-get';
import { OutboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusGet$Params } from '../fn/outbox-message-numbers/outbox-message-numbers-update-selected-out-box-message-numbers-delivery-status-get';
import { outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusPost } from '../fn/outbox-message-numbers/outbox-message-numbers-update-selected-out-box-message-numbers-delivery-status-post';
import { OutboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusPost$Params } from '../fn/outbox-message-numbers/outbox-message-numbers-update-selected-out-box-message-numbers-delivery-status-post';

@Injectable({ providedIn: 'root' })
export class OutboxMessageNumbersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `outboxMessageNumbersGetScheduledMessageNumbersWithPagination()` */
  static readonly OutboxMessageNumbersGetScheduledMessageNumbersWithPaginationPath = '/OutboxMessageNumbers/GetScheduledMessageNumbersWithPagination';

  /**
   * Get ScheduledMessage Numbers WithPagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outboxMessageNumbersGetScheduledMessageNumbersWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersGetScheduledMessageNumbersWithPagination$Response(params: OutboxMessageNumbersGetScheduledMessageNumbersWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfOutboxMessageNumbersWithPaginationDto>> {
    return outboxMessageNumbersGetScheduledMessageNumbersWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ScheduledMessage Numbers WithPagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outboxMessageNumbersGetScheduledMessageNumbersWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersGetScheduledMessageNumbersWithPagination(params: OutboxMessageNumbersGetScheduledMessageNumbersWithPagination$Params, context?: HttpContext): Observable<CustomResultOfOutboxMessageNumbersWithPaginationDto> {
    return this.outboxMessageNumbersGetScheduledMessageNumbersWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfOutboxMessageNumbersWithPaginationDto>): CustomResultOfOutboxMessageNumbersWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `outboxMessageNumbersGetScheduledMessageNumbersAndTextWithPagination()` */
  static readonly OutboxMessageNumbersGetScheduledMessageNumbersAndTextWithPaginationPath = '/OutboxMessageNumbers/GetScheduledMessageNumbersAndTextWithPagination';

  /**
   * Get ScheduledMessage Numbers And Text WithPagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outboxMessageNumbersGetScheduledMessageNumbersAndTextWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersGetScheduledMessageNumbersAndTextWithPagination$Response(params: OutboxMessageNumbersGetScheduledMessageNumbersAndTextWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfOutboxMessageNumbersWithPaginationDto>> {
    return outboxMessageNumbersGetScheduledMessageNumbersAndTextWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ScheduledMessage Numbers And Text WithPagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outboxMessageNumbersGetScheduledMessageNumbersAndTextWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersGetScheduledMessageNumbersAndTextWithPagination(params: OutboxMessageNumbersGetScheduledMessageNumbersAndTextWithPagination$Params, context?: HttpContext): Observable<CustomResultOfOutboxMessageNumbersWithPaginationDto> {
    return this.outboxMessageNumbersGetScheduledMessageNumbersAndTextWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfOutboxMessageNumbersWithPaginationDto>): CustomResultOfOutboxMessageNumbersWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `outboxMessageNumbersGetOutboxMessageNumbersAudit()` */
  static readonly OutboxMessageNumbersGetOutboxMessageNumbersAuditPath = '/OutboxMessageNumbers/GetOutboxMessageNumbersAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outboxMessageNumbersGetOutboxMessageNumbersAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersGetOutboxMessageNumbersAudit$Response(params: OutboxMessageNumbersGetOutboxMessageNumbersAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVmMongo>> {
    return outboxMessageNumbersGetOutboxMessageNumbersAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outboxMessageNumbersGetOutboxMessageNumbersAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersGetOutboxMessageNumbersAudit(params: OutboxMessageNumbersGetOutboxMessageNumbersAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVmMongo> {
    return this.outboxMessageNumbersGetOutboxMessageNumbersAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVmMongo>): CustomResultOfAuditVmMongo => r.body)
    );
  }

  /** Path part for operation `outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusGet()` */
  static readonly OutboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusGetPath = '/OutboxMessageNumbers/UpdateOutBoxMessageNumbersDeliveryStatus';

  /**
   * Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusGet$Response(params?: OutboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusGet(params?: OutboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusGet$Params, context?: HttpContext): Observable<Blob> {
    return this.outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusPost()` */
  static readonly OutboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusPostPath = '/OutboxMessageNumbers/UpdateOutBoxMessageNumbersDeliveryStatus';

  /**
   * Update OutBox Message Numbers Delivery Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusPost$Response(params: OutboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Update OutBox Message Numbers Delivery Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusPost(params: OutboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outboxMessageNumbersUpdateOutBoxMessageNumbersDeliveryStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusGet()` */
  static readonly OutboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusGetPath = '/OutboxMessageNumbers/UpdateSelectedOutBoxMessageNumbersDeliveryStatus';

  /**
   * بررسی دسترسی ویرایش وضعیت تحویل گیرندگان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusGet$Response(params?: OutboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی ویرایش وضعیت تحویل گیرندگان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusGet(params?: OutboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusGet$Params, context?: HttpContext): Observable<Blob> {
    return this.outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusPost()` */
  static readonly OutboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusPostPath = '/OutboxMessageNumbers/UpdateSelectedOutBoxMessageNumbersDeliveryStatus';

  /**
   * ویرایش انتخابی وضعیت تحویل گیرندگان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusPost$Response(params: OutboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش انتخابی وضعیت تحویل گیرندگان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusPost(params: OutboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outboxMessageNumbersUpdateSelectedOutBoxMessageNumbersDeliveryStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdGet()` */
  static readonly OutboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdGetPath = '/OutboxMessageNumbers/UpdateDeliveryStatusByDeliveryStatusAndScheduledMessageId';

  /**
   * Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdGet$Response(params?: OutboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdGet(params?: OutboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdGet$Params, context?: HttpContext): Observable<Blob> {
    return this.outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdPost()` */
  static readonly OutboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdPostPath = '/OutboxMessageNumbers/UpdateDeliveryStatusByDeliveryStatusAndScheduledMessageId';

  /**
   * Update Delivery Status By Delivery Status And Scheduled Message Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdPost$Response(params: OutboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Delivery Status By Delivery Status And Scheduled Message Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdPost(params: OutboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outboxMessageNumbersUpdateDeliveryStatusByDeliveryStatusAndScheduledMessageIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outboxMessageNumbersApplyingToGetNewDeliveryStatusGet()` */
  static readonly OutboxMessageNumbersApplyingToGetNewDeliveryStatusGetPath = '/OutboxMessageNumbers/ApplyingToGetNewDeliveryStatus';

  /**
   * Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outboxMessageNumbersApplyingToGetNewDeliveryStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  outboxMessageNumbersApplyingToGetNewDeliveryStatusGet$Response(params?: OutboxMessageNumbersApplyingToGetNewDeliveryStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return outboxMessageNumbersApplyingToGetNewDeliveryStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outboxMessageNumbersApplyingToGetNewDeliveryStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  outboxMessageNumbersApplyingToGetNewDeliveryStatusGet(params?: OutboxMessageNumbersApplyingToGetNewDeliveryStatusGet$Params, context?: HttpContext): Observable<Blob> {
    return this.outboxMessageNumbersApplyingToGetNewDeliveryStatusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `outboxMessageNumbersApplyingToGetNewDeliveryStatusPost()` */
  static readonly OutboxMessageNumbersApplyingToGetNewDeliveryStatusPostPath = '/OutboxMessageNumbers/ApplyingToGetNewDeliveryStatus';

  /**
   * Update Delivery Status By Send Return Ids To The Web Service.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outboxMessageNumbersApplyingToGetNewDeliveryStatusPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersApplyingToGetNewDeliveryStatusPost$Response(params: OutboxMessageNumbersApplyingToGetNewDeliveryStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return outboxMessageNumbersApplyingToGetNewDeliveryStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Delivery Status By Send Return Ids To The Web Service.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outboxMessageNumbersApplyingToGetNewDeliveryStatusPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersApplyingToGetNewDeliveryStatusPost(params: OutboxMessageNumbersApplyingToGetNewDeliveryStatusPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.outboxMessageNumbersApplyingToGetNewDeliveryStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `outboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId()` */
  static readonly OutboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageIdPath = '/OutboxMessageNumbers/GetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `outboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId$Response(params: OutboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfOutboxMessageNumbersCountByDeliveryStatusDto>> {
    return outboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `outboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  outboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId(params: OutboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId$Params, context?: HttpContext): Observable<CustomResultOfListOfOutboxMessageNumbersCountByDeliveryStatusDto> {
    return this.outboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfOutboxMessageNumbersCountByDeliveryStatusDto>): CustomResultOfListOfOutboxMessageNumbersCountByDeliveryStatusDto => r.body)
    );
  }

}
